import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const PaymentFlow = {
  /**
   * STEP 1: Payment Validation - First time CC capture
   */
  async validatePaymentMethod(userId) {
    try {
      const response = await axios.get(`${API}/payment/validation-required`, {
        withCredentials: true
      });
      return response.data;
    } catch (error) {
      console.error('Payment validation check failed:', error);
      throw error;
    }
  },

  /**
   * STEP 2: Payment Verification - Check before service access
   */
  async verifyPaymentForService(serviceName) {
    try {
      
      const response = await axios.get(`${API}/payment/verify-service/${serviceName}`, {
        withCredentials: true
      });
      
      return response.data;
    } catch (error) {
      console.error('Payment verification failed:', error);
      throw error;
    }
  },

 
};

export default PaymentFlow;